<template>
  <a-form :form="form">
    <a-row :gutter="16">
      <a-col :xs="{span: 24}" :lg="{span:12}">
        <a-form-item label="Date of PO">
          <a-date-picker
          placeholder="Select Date"
            :disabled="mode === 'Edit'"
            :format="getDefaultDateFormat"
            v-decorator="['tgl_buat', {rules: [{required: true}], initialValue: moment(initialData.informasi.tgl_buat, getDefaultDateFormat)}]"
          />
        </a-form-item>
        <a-form-item label="No PP">
          <v-select
            :disabled="(mode === 'Edit' && !isDraftEdited) || this.listPembelian.length>0"
            :clearable="false"
            class="m-select"
            @input="(e)=>{handleNoPp('manual', e)}"
            :options="dataPP"
            v-decorator="['no_pp', {rules: [{required: true}], initialValue: initialData.informasi.no_pp}]"
            label="no_pp"
          ></v-select>
          <!-- <a-select
            :disabled="mode === 'Edit'"
            showSearch
            @change="handleNoPp"
            v-decorator="['no_pp', {rules: [{required: true}], initialValue: initialData.informasi.no_pp}]"
          >
            <a-select-option v-for="item in dataPP" :key="item.no_pp">{{item.no_pp}}</a-select-option>
          </a-select>-->
        </a-form-item>
        <a-form-item label="Supplier">
          <v-select
            class="m-select"
            :clearable="false"
            @input="handleSupplier"
            :options="dataSupplier"
            v-decorator="['supplier', {rules: [{required: true}],initialValue: initialData.informasi.id_supplier && mode==='Edit' ? getDataSupplierEdit : initialData.informasi.id_supplier}]"
            label="nm_supplier"
          ></v-select>

          <!--<v-select-->
                  <!--class="m-select"-->
                  <!--:clearable="false"-->
                  <!--:options="dataSupplier"-->
                  <!--v-decorator="['supplier', {rules: [{required: true}],}]"-->
                  <!--:reduce="item=>item.nm_supplier"-->
                  <!--label="nm_supplier"-->
          <!--&gt;</v-select>-->

          <!-- <a-select
            showArrow
            showSearch
            @change="handleSupplier"
            v-decorator="['supplier', {rules: [{required: true}], initialValue: initialData.informasi.supplier}]"
          >
            <a-select-option
              v-for="item in dataSupplier"
              :key="item.nm_supplier"
            >{{item.nm_supplier}}</a-select-option>
          </a-select>-->
          <span><b>PKP</b> : {{ ispkp }}, <b>Domestik</b> : {{ isdomestik }}</span>
        </a-form-item>
        <a-form-item label="Description">
          <a-input
            v-decorator="['deskripsi', {rules: [{required: true}], initialValue: initialData.informasi.deskripsi}]"
          ></a-input>
        </a-form-item>
        <a-form-item label="Delivery Address">
          <a-auto-complete
            class="certain-category-search"
            dropdownClassName="certain-category-search-dropdown"
            :dropdownMatchSelectWidth="false"
            placeholder="input here"
            optionLabelProp="value"
            v-decorator="['lokasi', {rules: [{required: true}], initialValue: initialData.informasi.lokasi_pengiriman}]"
          >
            <template slot="dataSource">
              <a-select-option v-for="item in getSites" :key="item.value">{{item.value}}</a-select-option>
            </template>
            <a-input>
              <a-icon slot="suffix" type="search" class="certain-category-icon" />
            </a-input>
          </a-auto-complete>
          <!-- <a-select
            showSearch
            v-decorator="['lokasi', {rules: [{required: true}], initialValue: initialData.informasi.lokasi_pengiriman}]"
          >
            <a-select-option
              v-for="item in getSites"
              :key="item.value"
              :value="item.value"
            >{{item.label}}</a-select-option> 
          </a-select>-->
        </a-form-item>
      </a-col>
      <a-col :xs="{span: 24}" :lg="{span:12}">
        <a-row :gutter="9">
          <a-col :xs="{span: 12}" :lg="{span:8}">
            <a-form-item label="Is QC needed?">
              <a-radio-group
                buttonStyle="solid"
                @change="handleQc"
                :disabled="initialData.informasi.is_aset"
                v-decorator="['inc_qc', {rules: [{required: true}], initialValue: initialData.informasi.inc_qc}]"
              >
                <a-radio-button v-for="item in getQc" :key="item.id" :value="item.id">{{item.value}}</a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="9" style="display:none">
          <a-col :xs="{span: 12}" :lg="{span:8}">
            <a-form-item>
              <a-checkbox @change="handleShipping" :checked="initialData.informasi.check_shipping">Shipping Cost</a-checkbox>
              <a-input-number
              :min="0"
              class="m-width-full"
              :disabled="!initialData.informasi.check_shipping"
              placeholder="Input a number"
              v-decorator="['shipping', {rules: [{required: false}], initialValue: initialData.informasi.shipping}]"
              />
            </a-form-item>
          </a-col>
          <a-col :xs="{span: 12}" :lg="{span:6}">
              <a-form-item>
              <a-checkbox @change="handleTax" :checked="initialData.informasi.check_tax">Tax</a-checkbox>
              <a-input-number
                :min="1"
                :max="100"
                class="m-width-full"
                :formatter="value => `${value}%`"
                :parser="value => value.replace('%', '')"
                :disabled="!initialData.informasi.check_tax"
                v-decorator="['tax', {initialValue: initialData.informasi.tax}]"
              ></a-input-number>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="Document Needed">
          <a-checkbox-group
            v-decorator="['dokumen', {rules: [{required: reqDokumen}], initialValue: initialData.informasi.dokument }]"
          >
            <a-checkbox value="COC">Certificate Of Conformance (COC)</a-checkbox>
            <a-checkbox value="CPD" style="margin-left:0!important">Counterfeit Prevention Document</a-checkbox>
            <a-checkbox value="TR" style="margin-left:0!important">Test Report</a-checkbox>
          </a-checkbox-group>
        </a-form-item>
        <a-form-item label="Due Date">
          <a-date-picker
          placeholder="Select Date"
            :format="getDefaultDateFormat"
            v-decorator="['target_selesai', {rules: [{required: true}],
        initialValue: initialData.informasi.target_selesai}]"
          />
        </a-form-item>
        <!-- <div style="display:none">
        <a-form-item label="Vice President Finance Approval">
          <a-select
            disabled
            v-decorator="['bod', {rules: [{required: true}], initialValue: initialData.informasi.bod}]"
          >
            <a-select-option v-for="bod in getAllBOD" :key="bod.tlc">{{bod.tlc}} - {{bod.nama}}</a-select-option>
          </a-select>
        </a-form-item>
        </div> -->
        <!-- <a-form-item label="Note">
          <a-textarea
            placeholder="Write the note here ... "
            :rows="4"
            v-decorator="['catatan', {rules: [{required: false}], initialValue: initialData.informasi.catatan}]"
          />
        </a-form-item> -->
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import _ from "lodash";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "InformasiPo",
  mixins: [GlobalMethod],
  props: {
    data: {},
    listPembelian: {},
    mode: String,
    isDraftEdited: Boolean
  },
  data() {
    return {
      activeProject: [],
      kategori: String,
      dataPP: [],
      dataSupplier: [],
      supplier: "",
      dok: "",
      getQc: [
        {
          id: 1,
          value: "Yes"
        },
        {
          id: 0,
          value: "No"
        }
      ],
      reqDokumen: true,
      trigger:{
        taxBarier : true
      },
      ispkp: " - ",
      isdomestik: " - "
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters(["getSites", "getDefaultDateFormat", "getAuth", "getAllBOD", "getStandartFormatDate"]),
    initialData() {
      let informasi = {};
      if (this.data === undefined || this.data.length <= 0) {
        informasi = {
          supplier: "",
          deskripsi: "",
          tgl_buat: moment(),
          no_pp: "",
          lokasi_pengiriman: "",
          inc_qc: 1,
          dokument: ["COC"],
          check_group: [],
          test_report: "0",
          catatan: "",
          id_po: "",
          bod: "",
          check_tax: false,
          check_shipping: false,
          tax: "0",
          shipping: 0,
          id_supplier: "",
          id_pp: "",
          jenis_anggaran: null,
          target_selesai: moment(),
          tax_bearer: "0",
          tax_transaction: "1",
          is_aset: false,
        };
        return { informasi };
      } else {
        let tempDokumen;
        if (Array.isArray(this.data.dokumen[0])) {
          this.data.dokumen.shift();
          tempDokumen = this.data.dokumen;
        } else {
          tempDokumen = this.data.dokumen;
        }


        informasi = {
          supplier: this.data.supplier,
          deskripsi: this.data.deskripsi,
          tgl_buat: moment(this.data.tgl_buat),
          no_pp: this.data.no_pp,
          lokasi_pengiriman: this.data.lokasi,
          inc_qc: parseInt(this.data.inc_qc) ,
          check_group: [],
          dokument: tempDokumen,
          test_report: "1",
          catatan: this.data.catatan,
          id_po: this.data.id_po,
          bod: this.data.bod,
          check_tax: this.data.check_tax,
          check_shipping: this.data.check_shipping,
          tax: this.data.tax,
          shipping: this.data.shipping,
          id_supplier: this.data.id_supplier,
          id_pp: this.data.id_pp,
          jenis_anggaran: this.data.jns_anggaran,
          target_selesai: moment(this.data.target_selesai),
          tax_bearer: this.data.tax_bearer,
          tax_transaction: this.data.tax_transaction,
          is_aset: this.data.jenis_anggaran=="05" ? true : false,
        };

        return { informasi };
      }
    },
    getDataSupplierEdit(){
        if(this.mode === 'Edit' && this.dataSupplier.length > 0){
            let filter = _.filter(
                this.dataSupplier,
                obj =>
                    obj.id_supplier &&
                    obj.id_supplier.toLowerCase().indexOf(this.data.id_supplier.constructor === Object ? this.data.id_supplier.toLowerCase() : this.data.id_supplier.toLowerCase()) >= 0
            );

            return {id_supplier:filter[0].id_supplier,nm_supplier:filter[0].nm_supplier};
        }
    }
  },

  async created() {
    if (this.mode === "Edit") {
        await this.fetchPurchasing();
        await this.getNoPp();
    } else {
      await this.getNoPp();
      await this.fetchPurchasing();
    }
  },
  methods: {
    moment,
    handleNoPp(type, value) {
      let filter = _.filter(
        this.dataPP,
        obj =>
          obj.no_pp &&
          obj.no_pp.toLowerCase().indexOf(value.no_pp.toLowerCase()) >= 0
      );

      this.initialData.informasi.id_pp = filter[0].id_pp;
      if(filter[0].jns_anggaran=="05"){
        this.initialData.informasi.is_aset = true;
        this.$nextTick(() => {
            this.form.setFieldsValue({ inc_qc: type=='auto' ? parseInt(this.data.inc_qc) : 0 });
        });
        let target = [{
          target : {value : type=='auto' ? parseInt(this.data.inc_qc) : 0}
      }]
        this.handleQc(target[0]);
      }else{
        this.initialData.informasi.is_aset = false;
        this.$nextTick(() => {
            this.form.setFieldsValue({ inc_qc: type=='auto' ? parseInt(this.data.inc_qc) : 1 });
        });
        let target = [{
          target : {value : type=='auto' ? parseInt(this.data.inc_qc) : 1}
      }]
        this.handleQc(target[0]);
      }
      this.initialData.informasi.jenis_anggaran = filter[0].jns_anggaran;
      //this.form.setFieldsValue({ bod: filter[0].bod });
      this.form.setFieldsValue({ no_pp: value.no_pp });
    },
    handleSupplier(value) {
      let filter = _.filter(
        this.dataSupplier,
        obj =>
          obj.nm_supplier &&
          obj.nm_supplier
            .toLowerCase()
            .indexOf(value.nm_supplier.toLowerCase()) >= 0
      );

      if(filter.length>0){
        this.ispkp = filter[0].ispkp=='1' ? 'Yes': (filter[0].ispkp=='-'? '-' :'No')
        this.isdomestik = filter[0].lokasi=="LN" ? "No": (filter[0].lokasi=='-' ? '-' :'Yes')
      }

      this.initialData.informasi.id_supplier = filter[0].id_supplier;
      this.form.setFieldsValue({ supplier: value.nm_supplier });
    },
    handleRef() {
      this.form.validateFields(async (err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        values.check_tax = this.initialData.informasi.check_tax;
        values.check_shipping = this.initialData.informasi.check_shipping;
        values.id_po = this.initialData.informasi.id_po;
        values.id_supplier = this.initialData.informasi.id_supplier;
        values.id_pp = this.initialData.informasi.id_pp;

        let filter = _.filter(
          this.dataPP,
          obj =>
            obj.id_pp &&
            obj.id_pp
              .toLowerCase()
              .indexOf(values.id_pp.toLowerCase()) >= 0
        );
        values.jenis_anggaran = filter[0].jns_anggaran;

        if (this.mode=='Edit'){
          values.catatan = this.data.catatan;
        }


          if (Array.isArray(values.dokumen)) {
              if(values.dokumen.length > 0){
                  if (values.dokumen[0].includes(",")) {
                      values.dokumen.shift();
                  }
              }
          }
        
        let selectedPP = null;
        if(values.inc_qc === 1){
            // if(!values.dokumen.includes("COC")){
            //     this.form.setFields({dokumen: {errors: [new Error('COC is required')]}});
            // }else{
                // kebutuhan menentukan curency dari PP selected
                selectedPP = this.dataPP.filter(
                    obj => obj.id_pp.indexOf(this.initialData.informasi.id_pp) >= 0
                );
            // }

        }else{

            // kebutuhan menentukan curency dari PP selected
            selectedPP = this.dataPP.filter(
                obj => obj.id_pp.indexOf(this.initialData.informasi.id_pp) >= 0
            );
        }

        if((this.mode=='create' && this.initialData.informasi.id_po && this.initialData.informasi.id_po!="") || (this.mode=='Edit' && !this.isDraftEdited)){
          Event.$emit("poData", {
            informasi: values,
            selectedPP: selectedPP
          });
        }else{
          let formData = new FormData();
          Object.keys(values).forEach((key) => {
            if(key=='dokumen'){
              if(values[key][0]){
                formData.append(values[key][0]=='COC'?'coc': (values[key][0]=='CPD' ? 'cpd' :'test_report'), values[key][0]=='COC'?'1':(values[key][0]=='TR'?'1': (values[key][0]=='CPD'?'1':'0')));
              }
              if(values[key][1]){
                formData.append(values[key][1]=='COC'?'coc': (values[key][1]=='CPD' ? 'cpd' :'test_report'), values[key][1]=='COC'?'1':(values[key][1]=='TR'?'1': (values[key][1]=='CPD'?'1':'0')));
              }
              if(values[key][2]){
                formData.append(values[key][2]=='COC'?'coc': (values[key][2]=='CPD' ? 'cpd' :'test_report'), values[key][2]=='COC'?'1':(values[key][2]=='TR'?'1': (values[key][2]=='CPD'?'1':'0')));
              }
            }else if(key=='tgl_buat'){
              formData.append('tgl_po', moment(values[key]).format(this.getStandartFormatDate));
            }else if(key=='catatan'){
              formData.append('catatan', values[key] ? values[key] : '');
            }else if(key=='target_selesai'){
              formData.append('target_selesai', moment(values[key]).format(this.getStandartFormatDate));
            }else{
              formData.append(key, values[key]);
            }
          });

          Event.$emit("loadingBtnNext", true);
          await this.asyncAxiosPost("po/draft", "formdata", this.getAuth, formData)
          .then(async (response) => {
            values.id_po = response.id_po
            Event.$emit("poData", {
              informasi: values,
              selectedPP: selectedPP
            });
            Event.$emit("loadingBtnNext", false);
          })
          .catch((err) => {
            console.log(err);
            return
          });
        }
      });
    },
    getNoPp() {
      axios({
        method: "get",
        url: this.$serviceUrl + "po/no_pp",
        params: {
          id_pp: this.id,
          tlc: this.getAuth.username,
          mode: this.isDraftEdited ? 'create' : this.mode.toLowerCase()
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.dataPP = response.data.data;
          if (this.mode === "Edit") {
            let value = {
                no_pp : this.data ? this.data.no_pp : null
            }
            if (this.data)
              this.handleNoPp('auto', value);
          }
        })
        .catch(err => {
          this.displayMessage("error-aktif-project");
        });
    },
    fetchPurchasing() {
      axios({
        method: "get",
        url: this.$serviceUrl + "po/supplier",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.dataSupplier = response.data.data;
        })
        .catch(err => {
          if (!error.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },

    handleShipping(e){
      this.initialData.informasi.check_shipping = e.target.checked;
      if (this.initialData.informasi.check_shipping) {
        this.form.setFieldsValue({ shipping: "0" });
      } else {
        this.form.setFieldsValue({ shipping: "0" });
      }
    },
    handleTax(e) {
      this.initialData.informasi.check_tax = e.target.checked;
      if (this.initialData.informasi.check_tax) {
        this.form.setFieldsValue({ tax: "10" });
      } else {
        this.form.setFieldsValue({ tax: "0" });
      }
    },
    handleQc(e) {
      this.initialData.informasi.inc_qc = e.target.value;
      // let incVal = "";
      // if (e.target.value === "1") {
      //   incVal = "Ya";
      // } else {
      //   incVal = "Tidak";
      // }
      // this.form.setFieldsValue({
      //   inc_qc: incVal
      // });
        if(e.target.value === 1){
            // this.f = true;
            this.reqDokumen = true; // document need false karena permintaan oleh GTI 08/06/2021
            this.$nextTick(() => {
                this.form.validateFields(['dokumen'], {force: true});
            });
        }else if(e.target.value === 0){
            this.reqDokumen = false;
            this.$nextTick(() => {
                this.form.validateFields(['dokumen'], {force: true});
            });
        }
    },
    ChangetaxTransaction(val){
      this.initialData.informasi.tax_bearer = "0";
      this.trigger.taxBarier = val.target.value=="1" ? true : false;
    }
  },
  watch: {
    data(){
      if(this.data){
        if(this.data.tax_transaction=="1"){
          this.trigger.taxBarier = true;
        }else{
          this.trigger.taxBarier = false;
        }
      }
    }
  }

};
</script>